// Components
import { Timelinev1, BreadCrumb } from '../../components';
import { mleOnBoarding } from './timelinesteps';

// Actions
import { fetchBasicFormDataProcess, fetchMerchantLegalEntityDetailsRequest } from './redux/merchantLegalEntity.actions';
// Libraries
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, useParams } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { BUSINESS_SECTION_TYPE_MLE } from 'components/Onboarding/Mle/BusinessTab/contants';
import { mutateMleDataMerchant } from './merchantLegalEntity.utils';
import { MOCK_API_VALUE } from 'utils/constants/commonValues';
import { saveAndContinueDetails } from 'mockApiWiseReqRes';
import { OWNERSHIP_DETAILS_SAVE } from 'mockApiWiseReqRes/mockApiWise.constants';
import { BASICFORM_MLE_UPDATE } from './constants';
import { UBO_SECTION_TYPE } from 'components/Onboarding/Mle/UobTab/constant';

const getDraftData = (draftData, sectionType) => {
    const filteredData =
        draftData &&
        draftData?.forms?.[0]?.sections?.length &&
        draftData.forms[0].sections.find(section => section.type === sectionType);
    const formattedData = mutateMleDataMerchant(filteredData?.data || {}, sectionType)
    
    return formattedData;
    // return filteredData;
};

const CreateMle = ({ 
    actions, 
    history, 
    permissions,
    formData,
    formEvents,
    uniqueIdentifier,
    merchantLegalEntityData,
    isUpdate
}) => {
    const { location } = history;
    const locationArray = location.pathname.split('/');
    const event = locationArray[2];
    const merchantId = locationArray[4];
    let initialIntentId = formData?.forms?.[0]?.intentId ?? formData?.forms?.[0]?.intendId ?? null;
    const { basicSectionData, uboBasicDetails } = merchantLegalEntityData?.basicFormData;
    
    
    
    let isViewMode = (event === 'view') ? true : false;
    let isEditMode = (event === 'edit') ? true : false;
    useEffect(() => {
        // fetching business details basic form data
        let sectionType = BUSINESS_SECTION_TYPE_MLE;
        let entityCode = (isEditMode) ? null : BUSINESS_SECTION_TYPE_MLE;
        let formType = (isEditMode) ? BASICFORM_MLE_UPDATE.business : null;
        actions.fetchBasicFormDataProcess({sectionType, entityCode, formType});

        // fetching ownership details basic form data
        let payload = {
            sectionType: UBO_SECTION_TYPE,
            entityCode: UBO_SECTION_TYPE
        };
        if (isEditMode) {
            payload = {
                sectionType: UBO_SECTION_TYPE,
                formType: BASICFORM_MLE_UPDATE.ubo
            }
        }
        actions.fetchBasicFormDataProcess(payload);
    }, []);

    
    // const {
    //     timeline: { fields },
    //     uniqueIdentifier: { isInEditMode },
    // } = data;
    let draftData = formData; // temporary
    if (MOCK_API_VALUE) {
        draftData = saveAndContinueDetails(OWNERSHIP_DETAILS_SAVE);
    }
    
    const mleOnBoardSteps = mleOnBoarding(
        formEvents,
        location.pathname,
        permissions,
        event,
        merchantId,
        uniqueIdentifier,
        initialIntentId
    );

    // const merchantOnBoardSteps = merchantOnBoarding(
    //     fields,
    //     draftData,
    //     location.pathname,
    //     data,
    //     permissions
    // );
    
    const completedSection =mleOnBoardSteps && mleOnBoardSteps.filter(item => item.status === 'Complete');
        // merchantOnBoardSteps && merchantOnBoardSteps.filter(item => item.status === 'Complete');
    const lastSelected =
        completedSection.length &&
        completedSection[completedSection.length - 1];

    

    useEffect(() => {
        // Show dialog on explicit route leave
        function unloadRoute(event) {
            event.returnValue = 'Changes that you made may not be saved.';
        }

        window.addEventListener('beforeunload', unloadRoute);
        return () => {
            window.removeEventListener('beforeunload', unloadRoute);
        };
    }, [actions]);

    // useEffect(() => {
    //     // Send merchant dashboard when trying to access directly
    //     if (
    //         draftData &&
    //         draftData.length === 0 &&
    //         location.pathname !== '/mob/v1/create/merchant'
    //     ) {
    //         history.replace('/mob/v1');
    //     }
    // }, [draftData, history, location.pathname]);

    useEffect(() => {
        if (!lastSelected || isEditMode || isViewMode) {
            return;
        }
        if (lastSelected.nextPath && formEvents?.isFormSubmitted) {
            history.push(lastSelected.nextPath);
        } else {
            history.push(lastSelected.path);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const headingName = (isViewMode) ? 'View MLE' : (isEditMode) ? 'Edit MLE' : 'Create MLE';

    let mleFilterData = mleOnBoardSteps.filter((steps ) =>
        (Object.keys(formData?.forms?.[0]?.sections?.[0]?.data??{}).length>0 && steps.sectionType ===BUSINESS_SECTION_TYPE_MLE) || 
        (Object.keys(formData?.forms?.[0]?.sections?.[1]?.data??{}).length>0  && steps.sectionType ===UBO_SECTION_TYPE) || 
        (event === 'create')
      );
    
    return (
        <div className='merchant-legal-entity-wrapper'>
            <div className="create-merchant-wrap" id="create-merchant-section">
                <div className="bread-crumbs">
                    <h3>Create MLE</h3>
                    <BreadCrumb
                        breadCrumbs={[
                            {
                                name: 'MLE Onboarding',
                                link: '/mle-onboarding',
                            },
                            {
                                name: headingName,
                                link: '',
                            },
                        ]}
                    />
                </div>
                <div className="create-merchant">
                    <div className="left-section">
                        <Timelinev1
                            onboardingProcess={mleFilterData.length > 0 ? mleFilterData : mleOnBoardSteps}
                            isCreate={true}
                            heading="MLE Creation" 
                        />
                    </div>
                    <div className="right-section" style={{"margin-left": "10px"}}>
                        <Switch>
                            {mleOnBoardSteps.map(tab => (
                                <Route exact path={tab.path} key={tab.tabId}>
                                    {tab.component({
                                        ...tab,
                                        draftData: getDraftData(
                                            draftData,
                                            tab.sectionType
                                        ),
                                        mleOnBoardSteps,
                                        isEditMode: isEditMode,
                                        isViewMode: isViewMode,
                                        isUpdate: isUpdate,
                                        basicSectionData: (tab.name === 'Business Details') ? basicSectionData : uboBasicDetails?.basicSectionData,
                                        createdAt: draftData?.createdAt,
                                        updatedAt: draftData?.updatedAt,
                                    })}
                                </Route>
                            ))}
                        </Switch>

                        
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = ({ loader, merchantLegalEntityData }) => ({
    loader,
    merchantLegalEntityData
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchBasicFormDataProcess,
            fetchMerchantLegalEntityDetailsRequest
        },
        dispatch
    ),
});

CreateMle.propTypes = {
    actions: PropTypes.object,
    history: PropTypes.object,
    permissions: PropTypes.object
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateMle);
